import { useEffect } from 'react';
import { Card } from '../ui/Card.jsx';
import { Button } from '../ui/Button.jsx';
import { useAudio } from '../../hooks/useAudio.js';

export function EventCard({ event, eventRoll, secondaryEvents, onContinue, onStoryChoice }) {
  const audio = useAudio();

  const isStoryEvent = event.type === 'story_choice' ||
                       event.type === 'story_discovery' ||
                       event.type === 'story_blessing' ||
                       event.type === 'traveler_choice'; // NEW

  // Play event-specific sounds when event appears
  useEffect(() => {
    if (event) {
      switch (event.type) {
        case 'raid':
          audio.playSound('ui_warning');
          break;
        case 'warning':
          audio.playSound('ui_notice');
          break;
        case 'traveler':
        case 'traveler_choice':
          audio.playSound('event_traveler');
          break;
        case 'storm':
          // Rain ambience handled by DiceSettlement.jsx
          break;
        case 'bounty':
        case 'weather':
          audio.playSound('music_jingle_positive');
          break;
        case 'spoilage':
          audio.playSound('ui_negative');
          break;
        default:
          // Quiet or story events - no specific sound
          break;
      }
    }
  }, [event]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* Secondary events banner (NEW) */}
      {secondaryEvents && secondaryEvents.length > 0 && (
        <div className="mb-3 space-y-2">
          {secondaryEvents.map((se, idx) => (
            <div
              key={idx}
              className="bg-green-100 border-2 border-green-600 rounded-lg p-3 text-center"
            >
              <div className="text-2xl mb-1">{se.icon}</div>
              <div className="font-bold text-green-900">{se.name}</div>
              <div className="text-sm text-green-800">{se.message}</div>
            </div>
          ))}
        </div>
      )}

      {/* Main event card */}
      <Card title={event.name} icon={event.icon}>
      <p className="text-center text-amber-800 mb-4" id="event-description">{event.description}</p>
      {eventRoll !== null && (
        <p className="text-center text-sm text-amber-600 mb-6">Event roll: {eventRoll}</p>
      )}

      {isStoryEvent && event.choices ? (
        <div className="space-y-3 mt-4">
          <p className="font-bold text-center text-amber-900 mb-2">Choose your path:</p>
          {event.choices.map(choice => (
            <button
              key={choice.id}
              onClick={() => {
                audio.playSound('ui_confirm');
                onStoryChoice(choice.id);
              }}
              className="w-full p-3 bg-blue-600 hover:bg-blue-700 text-white rounded text-left transition-colors"
            >
              <div className="font-bold">{choice.label}</div>
              <div className="text-sm text-blue-100">{choice.description}</div>
              {choice.cost && (
                <div className="text-xs text-blue-200 mt-1">
                  Cost: {Object.entries(choice.cost).map(([resource, amount]) =>
                    `${amount} ${resource}`
                  ).join(', ')}
                </div>
              )}
            </button>
          ))}
        </div>
      ) : (
        <div className="text-center">
          <Button onClick={onContinue} aria-describedby="event-description">Continue</Button>
        </div>
      )}
      </Card>
    </>
  );
}
